import React, { useState } from 'react';
import { Button } from '@mui/material';
import ImageDrawer from '../drawers/ImageDrawer';

const OpenImageDrawerButton = ({ selectedPath, selectedFiles, disabled, imagesViewUrl, maxSelection, onSelectedChange }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedCount, setSelectedCount] = useState(0);

    const handleOpen = () => {
        if (selectedPath) setDrawerOpen(true);
    };

    const handleClose = () => {
        setDrawerOpen(false);
    };

    const handleSelectedChange = (files) => {
        setSelectedCount(files.length);
        if (onSelectedChange) onSelectedChange(files);
    };

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                onClick={handleOpen}
                disabled={!selectedPath || disabled}
                style={{ height: '100%' }}
            >
                Select Images ({selectedCount}/{maxSelection})
            </Button>

            <ImageDrawer
                open={drawerOpen}
                onClose={handleClose}
                imagesViewUrl={imagesViewUrl}
                directory={selectedPath}
                files={selectedFiles}
                maxSelection={maxSelection}
                onSelectedChange={handleSelectedChange}
            />
        </>
    );
};

export default OpenImageDrawerButton;
